import type { TableProps } from 'antd';
import { Breadcrumb, Button, Table } from 'antd';
import { FiPlus } from 'react-icons/fi';

import { Layout } from '../../components/layout';
import { OrganizationUnitListDrawer } from './components';
import {
  BREADCRUMBS,
  ORGANIZATION_UNIT_LISTS_COLUMNS,
} from './OrganizationUnitLists.constants.tsx';
import type {
  OrganizationUnitListsProps,
  OrganizationUnitListType,
} from './OrganizationUnitLists.types.ts';

import './OrganizationUnitLists.styles.css';
import { useTranslation } from 'react-i18next';
import { ConfirmDeleteButton } from '../../components/confirm-delete-button';
import { Skeleton } from '../admin/components';
import { useEffect } from 'react';

export default function OrganizationUnitLists({
  organizationUnitLists,
  isLoading,
  openOrganizationUnitListDrawer,
  onOpenOrganizationUnitListDrawer,
  onCloseOrganizationUnitListDrawer,
  onSubmitOrganizationUnitList,
  onDeleteOrganizationUnitLists,
  setSelectedOrganizationUnitListKeys,
  organizationUnitListId,
  itemsToDeleteCount,
}: OrganizationUnitListsProps) {
  const { t } = useTranslation();
  const rowSelection: TableProps<OrganizationUnitListType>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedOrganizationUnitListKeys(selectedRowKeys);
    },
  };

  useEffect(() => {
    document.title = `Administration ${t('pages.admin.module.organization-unit-lists')}`;
  }, [t]);

  return (
    <Layout>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="admin-page">
          <Breadcrumb className="breadcrumb" items={BREADCRUMBS} />

          <div className="admin-page-bar">
            <h1 className="admin-page-bar--title">
              {t('pages.admin.module.organization-unit-lists')}
            </h1>
            <div className="admin-page-bar--actions">
              <ConfirmDeleteButton
                onSubmit={onDeleteOrganizationUnitLists}
                count={itemsToDeleteCount}
                disabled={itemsToDeleteCount === 0}
              />
              <Button
                icon={<FiPlus />}
                iconPosition="start"
                size="large"
                type="primary"
                onClick={(event) => onOpenOrganizationUnitListDrawer(event, null)}
              >
                {t('common.add-new')}
              </Button>
            </div>
          </div>
          <Table<OrganizationUnitListType>
            rowKey="id"
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            columns={ORGANIZATION_UNIT_LISTS_COLUMNS}
            dataSource={organizationUnitLists}
            onRow={(record) => {
              return {
                onClick: (event: React.MouseEvent<HTMLButtonElement>) =>
                  onOpenOrganizationUnitListDrawer(event, record?.id || null),
              };
            }}
          />
          {openOrganizationUnitListDrawer && (
            <OrganizationUnitListDrawer
              open={openOrganizationUnitListDrawer}
              onClose={onCloseOrganizationUnitListDrawer}
              onSubmit={onSubmitOrganizationUnitList}
              organizationUnitListId={organizationUnitListId}
            />
          )}
        </div>
      )}
    </Layout>
  );
}
